import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const PersonDedupePage = withSuspense(lazy(() => import('./person-dedupe.page')));
export default PersonDedupePage; 